var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_871_322",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0H11.5V11.0003H0.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_871_322)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99954 0.824101C6.63071 0.824101 7.24266 0.947845 7.81883 1.19124C8.37573 1.42639 8.87495 1.76333 9.30535 2.19373C9.73441 2.62279 10.0727 3.12335 10.3078 3.68024C10.5512 4.25642 10.675 4.86837 10.675 5.49954C10.675 6.13071 10.5512 6.74266 10.3078 7.31883C10.0727 7.87573 9.73575 8.37495 9.30535 8.80535C8.87629 9.23441 8.37573 9.57269 7.81883 9.80783C7.24266 10.0512 6.63071 10.175 5.99954 10.175C5.36837 10.175 4.75642 10.0512 4.18024 9.80783C3.62335 9.57269 3.12413 9.23575 2.69373 8.80535C2.26467 8.37629 1.92639 7.87573 1.69124 7.31883C1.44785 6.74266 1.3241 6.13071 1.3241 5.49954C1.3241 4.86837 1.44785 4.25642 1.69124 3.68024C1.92639 3.12335 2.26333 2.62413 2.69373 2.19373C3.12279 1.76467 3.62335 1.42639 4.18024 1.19124C4.75642 0.947845 5.36837 0.824101 5.99954 0.824101ZM5.99954 -0.000976562C2.9619 -0.000976562 0.499023 2.4619 0.499023 5.49954C0.499023 8.53718 2.9619 11.0001 5.99954 11.0001C9.03718 11.0001 11.5001 8.53718 11.5001 5.49954C11.5001 2.4619 9.03718 -0.000976562 5.99954 -0.000976562Z",
    fill: "#7F68FB"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19967 5.0874H3.79926C3.57097 5.0874 3.38672 5.27165 3.38672 5.49994C3.38672 5.72823 3.57097 5.91248 3.79926 5.91248H8.19967C8.42796 5.91248 8.61221 5.72823 8.61221 5.49994C8.61221 5.27165 8.42796 5.0874 8.19967 5.0874Z",
    fill: "#7F68FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.99ce1eebb7cbdc8d1b290ed7f5cc2511.svg";
export { ForwardRef as ReactComponent };